// test658
(658 && 0);
